function initArticle2BannerAnimation() {
  document.querySelectorAll('.js-article-2-banner').forEach(banner => {
    if (banner.dataset.initialized === 'true') return;

    const block = banner.querySelector('.js-article-2-banner-block');
    if (!block) return;

    banner.dataset.initialized = 'true';

    let targetX = 0, targetY = 0;
    let currentX = 0, currentY = 0;
    let mouseX = 0, mouseY = 0;
    let rect = banner.getBoundingClientRect();

    const blockWidth = block.offsetWidth;

    function lerp(start, end, speed) {
      return start + (end - start) * speed;
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function updateTargetPosition() {
      rect = banner.getBoundingClientRect();

      const relativeX = mouseX - rect.left;
      const relativeY = mouseY - rect.top;

      const absoluteX = clamp(mouseX + 2, 0, document.body.clientWidth - blockWidth);

      targetX = absoluteX - rect.left;
      targetY = relativeY + 2;
    }

    function animate() {
      updateTargetPosition();
      currentX = lerp(currentX, targetX, 0.35);
      currentY = lerp(currentY, targetY, 0.35);

      block.style.transform = `translate(${currentX}px, ${currentY}px)`;
      requestAnimationFrame(animate);
    }

    document.body.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });

    window.addEventListener('scroll', () => {
      rect = banner.getBoundingClientRect();
    });

    rect = banner.getBoundingClientRect();
    mouseX = rect.left + rect.width / 2;
    mouseY = rect.top + rect.height / 2;
    updateTargetPosition();

    animate();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initArticle2BannerAnimation();
});